module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5031/images/default-avatar.png"